import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';
import { IFormSurrogateParentAppointment } from "../Models/Forms/IFormSurrogateParentAppointment";

@Injectable()
export class FormSurrogateParentAppointmentService  extends  BaseService {
  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getFormSurrogateParentAppointment(id: number) {
    return this._http.get(this._baseUrl + "api/FormSurrogateParentAppointment/" + id)
      .map((response: IFormSurrogateParentAppointment) => response as IFormSurrogateParentAppointment)
      .catch(this.errorHandler);
  }

  insertUpdateFormSurrogateParentAppointment(formSurrogateParentAppointmentDetails: IFormSurrogateParentAppointment) {
    return this._http.post(this._baseUrl + 'api/FormSurrogateParentAppointment', formSurrogateParentAppointmentDetails)
      .map((response: IFormSurrogateParentAppointment) => response as IFormSurrogateParentAppointment)
      .catch(this.errorHandler);
  }

  validateForm(id: number) {
    return this._http.get(this._baseUrl + "api/FormSurrogateParentAppointment/ValidateForm" + id)
      .map((response: string[]) => response as string[])
      .catch(this.errorHandler)
  }

  deleteSurrogateParentAppointment(id) {
    return this._http.delete(this._baseUrl + "api/FormSurrogateParentAppointment" + id)
      .map((response: IFormSurrogateParentAppointment) => response as IFormSurrogateParentAppointment)
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }
 
}
